import { DynamicForm, LwFormSelect } from 'redesign';
import { Box, Grid } from '@mui/material';
import { Section } from 'shared/components/common/form-section';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { IssueDocumentFormProps } from './issue-document-form.types';
import { FlexWorkerFormSelect } from '../../../../flexWorkers/flex-worker-form-select';
import { IssueDocumentFormData } from '../issue-document-form-content/issue-document-form-content.types';

export const IssueDocumentForm = ({
  selectedDocumentModel,
  onDocumentTypeChange,
  availableDocuments,
}: IssueDocumentFormProps) => {
  const { t } = useTranslation(['hq-screen-specific', 'web-common']);
  const formMethods = useFormContext<IssueDocumentFormData>();

  return (
    <Box width={'100%'}>
      <Grid container>
        <Section
          sectionLabel={t('document_form.document_details_section_title', {
            ns: 'hq-screen-specific',
          })}
        >
          <Grid item xs={12}>
            <LwFormSelect
              control={formMethods.control}
              name="documentType"
              label={t('table_headers.document_type', { ns: 'web-common' })}
              defaultLabel={t('document_form.select_document_type', {
                ns: 'hq-screen-specific',
              })}
              options={availableDocuments}
              onChange={(e: React.ChangeEvent<{ value: string }>) => {
                onDocumentTypeChange(e.target.value);
              }}
              rules={{ required: true }}
            />
          </Grid>
        </Section>
        <Section sectionLabel={t('flex_worker_select_section.title', { ns: 'hq-screen-specific' })}>
          <Grid item xs={12}>
            <Box display="flex" flex={1}>
              <FlexWorkerFormSelect
                name="flexWorkerOption"
                label={t('flex_worker_select_section.label', { ns: 'hq-screen-specific' })}
              />
            </Box>
          </Grid>
        </Section>
        <DynamicForm config={selectedDocumentModel} />
      </Grid>
    </Box>
  );
};
